import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';
import Filters from '../../components/Filters';
import HomesResults from './HomesResults';
import AreaInfo from '../../components/AreaInfo';


const sortOptions = [
  { title: 'City', field: ['address.addressLocality', 'sqft'] },
  { title: 'Price Low To High', field: ['price', 'sqft'] },
  { title: 'Price High To Low', field: ['price', 'sqft'], dir: ['desc', 'asc'] },
  { title: 'Address', field: 'address.streetAddress' },
  { title: 'State', field: ['address.addressRegion', 'sqft'] },
];

class Homes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      showMap: false,
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { area, page } = this.props;
    const { sort, showMap } = this.state;

    return (
      <PageWrapper>
        <PageHelmet
          custom
          title={`Available Condos in ${get(area, 'name') || 'suburban Detroit'}`}
        >
          <meta name="description" content={`Browse new condos from Woodbridge Communities in the ${get(area, 'name') || 'suburban Detroit'} area.`} />
        </PageHelmet>
        <InsideHeader
          h1="Our Condos"
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuFind />
        <Filters
          type="homes"
          filterOptions={[
            {
              type: 'SingleSelect',
              filter: 'Area',
              title: 'City',
              placeholder: 'All Cities',
              routeParam: 'communityMarketArea',
            },
            {
              type: 'MultiSelect',
              filter: 'Beds',
              title: 'Beds',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Baths',
              title: 'Baths',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Community',
              title: 'Community',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Price',
              title: 'Price Range',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'SchoolDistrict',
              title: 'School Districts',
              placeholder: 'All Districts',
            },
            {
              type: 'MultiSelect',
              filter: 'Status',
              title: 'Status',
              placeholder: 'Any Status',
            },
          ]}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          showMap={showMap}
          onToggleMap={this.setShowMap}
        />
        <HomesResults sort={sort} showMap={showMap} />
        {
          area &&
          <AreaInfo area={area} />
        }
      </PageWrapper>
    );
  }
}

Homes.propTypes = {
  area: PropTypes.object,
  page: PropTypes.object.isRequired,
};

Homes.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    page: 'homes_results',
  },
  {
    required: {},
  },
)(Homes);



// WEBPACK FOOTER //
// ./src/pages/Homes/index.js